import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('UI crash:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))] flex items-center justify-center p-6">
          <div className="max-w-lg rounded-lg border border-white/10 bg-[hsl(var(--surface-1))] p-6 space-y-3">
            <h1 className="text-lg font-semibold">Something went wrong</h1>
            <p className="text-sm text-[hsl(var(--text-2))]">
              The page crashed in your browser. Try a hard refresh, or clear site data for agents.redserp.com and sign in again.
            </p>
            <pre className="text-xs overflow-auto rounded bg-black/30 p-3 text-[hsl(var(--text-3))]">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <button
              type="button"
              className="rounded-md bg-[hsl(var(--primary))] px-3 py-2 text-sm font-medium text-black"
              onClick={() => window.location.assign('/login')}
            >
              Go to login
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
